import AccessibilityForm from "../../../../src/pages/pricing/contacts/accessibility_form.md";
import AccessibilityLeftContent from "../../../../src/pages/pricing/contacts/accessibility-left.md";
import * as React from 'react';
export default {
  AccessibilityForm,
  AccessibilityLeftContent,
  React
};